import { render, staticRenderFns } from "./IntroHotel.vue?vue&type=template&id=15281d1e&scoped=true&"
import script from "./IntroHotel.vue?vue&type=script&lang=js&"
export * from "./IntroHotel.vue?vue&type=script&lang=js&"
import style0 from "./IntroHotel.vue?vue&type=style&index=0&id=15281d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15281d1e",
  null
  
)

export default component.exports